import React from 'react';
import { fetchAuthSession, getCurrentUser, signOut } from 'aws-amplify/auth';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { TextButton } from './common';
import { loadAuth2, loadGapiInsideDOM } from 'gapi-script';
import aws_config from '../../auth/awsConfig';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import AgentAvatar from './AgentAvatar';

class UserAccount extends React.Component {
  state = {
    showLogout: false,
    username: '',
    openMenu: false,
    anchorEl: null,
    accountStatus: '',
  };

  constructor(props) {
    super(props);
  }

  onSignOut = () => {
    signOut().then(async () => {
      const gapi = await loadGapiInsideDOM();
      await loadAuth2(gapi, aws_config.gg_client_id, '');
      const auth = gapi.auth2;

      auth
        .getAuthInstance()
        .signOut()
        .then(() => {
          console.log('User signed out.');

          window.history.pushState({}, document.title, '/form');
          window.location.pathname = '/form';
        });
    });
  };

  componentDidMount() {
    getCurrentUser()
      .then((user) => {
        if (user) {
          if (user.username.startsWith('Google_')) {
            this.setState({
              accountStatus: 'GOOGLE',
              showLogout: true,
              username: user.signInDetails?.loginId || user.username, // Set username as email if it starts with "Google_"
            });
          } else {
            this.setState({
              accountStatus: 'USERNAME',
              showLogout: true,
              username: user.username,
            });
          }
        }
      })
      .catch(() => console.log('Not signed in'));
  }

  handleClick = (event) => {
    this.setState({ openMenu: true, anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ openMenu: false, anchorEl: null });
  };

  render() {
    if (this.state.showLogout) {
      return (
        <div
          className="account-container"
          style={{ marginLeft: 8, display: 'flex', alignItems: 'center' }}
        >
          <TextButton
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={this.handleClick}
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <AgentAvatar
              name={this.state.username}
              size={24}
              borderRadius="6px"
              fontSize="0.75em"
              sx={{ mr: 1, border: '2px solid #fff' }}
            />
            {this.state.username}
          </TextButton>
          <Menu
            open={this.state.openMenu}
            anchorEl={this.state.anchorEl}
            onClose={this.handleClose}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <MenuItem onClick={this.onSignOut}>
              <ExitToAppIcon style={{ marginRight: 8 }} /> {/* Add the icon */}
              Log out
            </MenuItem>
          </Menu>
        </div>
      );
    } else {
      return '';
    }
  }
}

export default UserAccount;
